import { useEffect, useRef } from "react";

// JS-driven logo animation (requestAnimationFrame) for maximum mobile compatibility.
// Slow spin that decelerates naturally to a stop, holds ~3s, then loops forever.
const SPIN_MS = 4000;
const PAUSE_MS = 3000;
const easeOutCubic = (p) => 1 - Math.pow(1 - p, 3);

export function Logo({ className = "", alt = "The World Promotions" }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    let raf;
    let start = null;
    const cycle = SPIN_MS + PAUSE_MS;
    const tick = (ts) => {
      if (start === null) start = ts;
      const t = (ts - start) % cycle;
      const deg = t < SPIN_MS ? easeOutCubic(t / SPIN_MS) * 360 : 360;
      el.style.transform = `rotate(${deg}deg)`;
      el.style.webkitTransform = `rotate(${deg}deg)`;
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);
  return <img ref={ref} src="/logo.png" alt={alt} className={className} style={{ willChange: "transform" }} />;
}
